import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-redirect-patient-esignature',
  templateUrl: './redirect-patient-esignature.component.html',
  styleUrls: ['./redirect-patient-esignature.component.scss']
})
export class RedirectPatientEsignatureComponent implements OnInit {

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['event'] === 'signing_complete') {
        window.parent.postMessage("closePatientIframe", "/");
      }
    })
  }

}
